(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/prolongation/assets/javascripts/views/wagers.js') >= 0) return;  svs.modules.push('/components/numbergames/prolongation/assets/javascripts/views/wagers.js');

'use strict';

svs.numbergames.prolongation.views.Wagers = Marionette.CollectionView.extend({
  productName: '',
  className: 'prolongation-wagers col-xs-12 col-md-8 col-md-offset-2 col-lg-6 col-lg-offset-3',
  childViewEventPrefix: false,
  childViewTriggers: {
    prolongWager: 'childview:prolongWager',
    showDetails: 'childview:showDetails'
  },
  childView: svs.numbergames.prolongation.views.Wager,
  emptyView: Marionette.View.extend({
    className: 'prolongation-no-wagers prolongation-branding-fc align-center ',
    template(data) {
      return svs.numbergames.prolongation.templates.no_wagers(data);
    },
    templateContext() {
      return {
        productName: this.getOption('productName')
      };
    }
  }),
  initialize() {
    svs.numbergames.prolongation.logger.debug('views.Wagers Initialized with options', this.options);
    svs.core.detect.breakpoint.on('change', this.breakpointChanged, this);
  },
  onChildviewShowDetails(child) {
    this.updateWager(child, () => child.triggerMethod('openDetails', child));
  },
  onChildviewProlongWager(child) {
    this.updateWager(child, () => this.triggerMethod('prolongWager', child));
  },
  updateWager(child, success) {
    if (!child) {
      svs.numbergames.prolongation.logger.info('views.Wagers Missing childView, update wager failed.');
      return;
    }
    const storageKey = "prolong_".concat(child.model.get('wagerId'));
    svs.components.Storage.browser.remove(storageKey, child.model.get('productId'), () => {
      this.collection.updateWager(child.model.get('wagerId'), {
        success,
        context: this
      });
    });
  },
  breakpointChanged(_ref) {
    let current = _ref.current,
      was = _ref.was;
    if (current === 'xs' || was === 'xs') this.render();
  },
  onDestroy() {
    svs.core.detect.breakpoint.off('change', this.breakpointChanged);
  }
});

 })(window);